import React from 'react';
import { FormattedMessage } from 'react-intl';

function DashboardMetricCard({
  currentDetail,
  currentValue,
  labelId,
  previousDetail,
  previousValue,
  testId
}) {
  return (
    <article className="dashboard-metric-card" data-testid={testId}>
      <h3 className="dashboard-metric-card__label"><FormattedMessage id={labelId}/></h3>
      <div className="dashboard-metric-card__periods">
        <div className="dashboard-metric-card__period dashboard-metric-card__period--current">
          <span className="dashboard-metric-card__period-label">
            <FormattedMessage id="pages.dashboard.currentPeriod"/>
          </span>
          <strong className="dashboard-metric-card__value">{currentValue}</strong>
          {currentDetail && <div className="dashboard-metric-card__detail">{currentDetail}</div>}
        </div>
        <div className="dashboard-metric-card__period dashboard-metric-card__period--previous">
          <span className="dashboard-metric-card__period-label">
            <FormattedMessage id="pages.dashboard.previousPeriod"/>
          </span>
          <strong className="dashboard-metric-card__value dashboard-metric-card__value--previous">
            {previousValue}
          </strong>
          {previousDetail && <div className="dashboard-metric-card__detail">{previousDetail}</div>}
        </div>
      </div>
    </article>
  );
}

export { DashboardMetricCard };
